import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as relay from '../../../../../relay'
import { Api } from '../../api.service'
import type { TypeParams } from '../../types'

import { getActionsConfig } from './action'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * TODO:
 */
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create(
    'RateRuleApplicationPlugin',
  )

  /** @see {@link Api} */
  public readonly api: Api = ngCore.inject(Api)

  /** @see {@link relay.processes.Feature} */
  public readonly processesFeature = ngCore.inject(relay.processes.Feature)

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
    this.feature.registerEffects(
      effects.applyRulesOnRequest(this),
      effects.openProcessesSlideout(this),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export interface Params {
      collection: ec.Collection<TypeParams>
    }
  }
}
